module.exports = __webpack_public_path__ + "img/case1.d7b19075.jpg";